"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _uwActions = require("../actions/uw-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  uwDecisionsByApplicationUuid: {// 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b': {
    //   applicationUuid: '',
    //   decision: 'PREAPPROVED',
    //   min: undefined, // number
    //   max: undefined, // number
    //   products: [
    //     {
    //       id: '', // compound tier + term
    //       rate: undefined, // number
    //       term: undefined, // number
    //       tier: undefined, // number
    //       min: undefined, // number
    //       max: undefined, // number
    //     }
    //     ...
    //   ]
    // }
  },
  loading: false,
  error: ''
};

function parseUWProductMinMax(uwDecision) {
  return (uwDecision.products || []).reduce(function (result, p) {
    return {
      min: typeof result.min === 'undefined' ? p.min : Math.min(result.min, p.min),
      max: typeof result.max === 'undefined' ? p.max : Math.max(result.max, p.max)
    };
  }, {
    min: undefined,
    max: undefined
  });
}
/**
 * @deprecated Use offer reducer for actual data from server, this is just stubs
 */


var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, "".concat(_uwActions.GET_UW_DECISION, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true,
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_uwActions.GET_UW_DECISION, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var applicationUuid = action.payload.applicationUuid;
  var uwDecision = state.uwDecisionsByApplicationUuid[applicationUuid] || {};
  var uwProductMinMax = parseUWProductMinMax(action.payload);
  return _objectSpread(_objectSpread({}, state), {}, {
    uwDecisionsByApplicationUuid: _objectSpread(_objectSpread({}, state.uwDecisionsByApplicationUuid), {}, (0, _defineProperty2.default)({}, applicationUuid, _objectSpread(_objectSpread({}, uwDecision), {}, {
      applicationUuid: applicationUuid,
      decision: action.payload.decision,
      min: uwProductMinMax.min,
      max: uwProductMinMax.max,
      products: action.payload.products.map(function (p) {
        return Object.assign({}, p, {
          id: "".concat(p.tier, "-").concat(p.term)
        });
      })
    }))),
    loading: false,
    error: ''
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;